<template>
    <header class="services-modal-info-modal info-modal">
        <div class="info-modal__info">
            <div class="info-modal__desc">
                <div class="info-modal__title">
                    {{label}}
                </div>
                <div class="info-modal__subtitle">
                    {{description}}
                </div>
            </div>
        </div>
        <div 
            class="info-modal__close"
            @click="closeModal"
        >
            {{$t('ui.close')}}

            <svg-icon
                original
                name="icons/close-pink"
            />
        </div>
    </header>
</template>

<script>

export default {
    name: "OInfoModalSKHeader",
    props: {
        label: {
            type: String,
            default: ''
        },
        description: {
            type: String,
            default: ''
        }
    },
    methods: {
        closeModal() {
            this.$emit('closeModal')
        }
    }
}
</script>

<style lang="scss">
@import "theme";
</style>
